<template>
  <form @submit.prevent="lauchFormSubmitted" ref="form">
    <slot name="additionnalFieldsTop"></slot>
    <div
      v-for="(field, i) in fields"
      :key="i"
      :class="[inputContainerClass, field.class || '']"
      :style="[!fieldsDisplayed[i] ? { display: 'none' } : {}]"
    >
      <InputComponent
        v-if="fieldsDisplayed[i]"
        :ref="`input_${field.propertyName}`"
        v-model="filledFields[field.propertyName]"
        v-bind="{
          ...field,
          ...(field.inputProps || {}),
          ...(field.inputPropsComputed
            ? field.inputPropsComputed(filledFields) || {}
            : {}),
          class: '',
        }"
        @input="() => onFieldChanged(field.propertyName, i)"
        :value="filledFields[field.propertyName]"
        :validate="
          data => {
            if (!field.validate) return ''
            return field.validate(data, filledFields)
          }
        "
      ></InputComponent>
    </div>
    <button ref="internalSubmitButton" type="submit" class="hidden"></button>
    <slot name="submitButton">
      <button
        class="buttonComponent w-full"
        type="submit"
        :loading="loading"
        :rounded="false"
      >
        <slot name="submitButtonText"></slot>
      </button>
    </slot>
    <slot name="fieldsEnd"></slot>
  </form>
</template>

<script>
import InputComponent from './InputComponent.vue'

export default {
  name: 'FormComponent',
  components: { InputComponent },
  props: {
    fields: {
      type: Array,
      default: () => {
        return []
      },
    },
    onFormSubmited: {
      type: Function,
      default: data => {},
    },
    inputContainerClass: {
      type: String,
      default: '',
    },
    rightSectionPictureSrc: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filledFields: {},
      reloadInputContentFunctions: [],
      fieldsDisplayed: [],
    }
  },
  mounted() {
    this.setDefaultFields()
    this.updateModelValue()
    setTimeout(this.setDefaultFields, 500)
  },
  methods: {
    setDefaultFields(forceDefaultValues = false) {
      if (!Array.isArray(this.fields)) return
      const newFilledFields = {}
      this.fields.forEach(field => {
        if (forceDefaultValues) {
          newFilledFields[field.propertyName] = field.defaultValue || ''
          return
        }
        if (typeof this.filledFields[field.propertyName] == 'boolean') {
          newFilledFields[field.propertyName] =
            this.filledFields[field.propertyName]
          return
        }
        if (typeof this.filledFields[field.propertyName] == 'number') {
          newFilledFields[field.propertyName] =
            this.filledFields[field.propertyName]
          return
        }
        if (typeof field.defaultValue == 'boolean') {
          newFilledFields[field.propertyName] = field.defaultValue
          return
        }
        if (typeof field.defaultValue == 'number') {
          newFilledFields[field.propertyName] = field.defaultValue
          return
        }
        if (field.type == 'toggle') {
          newFilledFields[field.propertyName] = false
          return
        }
        newFilledFields[field.propertyName] =
          this.filledFields[field.propertyName] || field.defaultValue || ''
      })
      this.filledFields = newFilledFields
      this.reloadInputContent()
    },
    setFieldValue(fieldId, value) {
      let input = this.$refs[`input_${fieldId}`]
      if (!input) {
        console.log('input not found for id ' + fieldId)
        return
      }
      input = input[0] || input
      const field = this.fields.find(field => field.propertyName == fieldId)
      if (!field) {
        console.log(`field with id ${fieldId} not found`)
        return
      }
      let valueToSet = value
      if (field.formatOptionsDisplay) {
        valueToSet = field.formatOptionInputDisplay(value)
      }
      input.externalSetValue(valueToSet)
    },
    updateModelValue() {
      const newFilledFields = {}
      this.fields.forEach(field => {
        newFilledFields[field.propertyName] =
          this.filledFields[field.propertyName] || field.defaultValue || ''
      })
      this.filledFields = newFilledFields
      this.reloadInputContent()
    },
    submit() {
      this.reloadInputContent()
      this.internalSubmitForm()
    },
    internalSubmitForm() {
      if (!this.$refs.internalSubmitButton) return
      this.$refs.internalSubmitButton.click()
    },
    reloadInputContent() {
      this.reloadInputContentFunctions.forEach(reloadingFunction => {
        reloadingFunction()
      })
      // this.$forceUpdate()
    },
    refreshDisplayedFields() {
      const fieldsDisplayed = []
      this.fields.forEach((field, index) => {
        if (!field.showFieldIf) {
          fieldsDisplayed[index] = true
          return
        }
        fieldsDisplayed[index] = field.showFieldIf(this.filledFields)
      })
      this.fieldsDisplayed = fieldsDisplayed
    },
    onFieldChanged(fieldId, position) {
      this.refreshDisplayedFields()
      const currentData = this.getFormResponseData()
      this.$emit('fieldChanged', currentData, fieldId)
      if (this.fields[position].onChanged)
        this.fields[position].onChanged(currentData[fieldId], currentData)
      this.fields.forEach(el => {
        if (el.onFormUpdate) el.onFormUpdate(currentData, fieldId)
      })
    },
    lauchFormSubmitted() {
      const responseData = this.getFormResponseData()
      this.$emit('formSubmited', responseData)
    },
    getFormResponseData() {
      const filledFieldsToSend = {}
      // Object.keys(this.filledFields).forEach((propertyName, index) => {
      //   const value = this.filledFields[propertyName];
      //   const sourceField = this.fields.find((field) => {
      //     return field.propertyName == propertyName;
      //   });
      //   if (!sourceField?.formatOptionsDisplay) {
      //     filledFieldsToSend[propertyName] = value;
      //     return;
      //   }
      //   const sourceOptions = sourceField.options;
      //   const displayOptions = sourceField.options.map(
      //     sourceField.formatOptionsDisplay
      //   );
      //   const selectedOptionId = displayOptions.indexOf(value);
      //   filledFieldsToSend[propertyName] = sourceOptions[selectedOptionId];
      // });
      const dataToSend = JSON.parse(JSON.stringify(this.filledFields))
      return dataToSend
    },
  },
  computed: {
    fieldsData() {
      return JSON.parse(JSON.stringify(this.filledFields))
    },
  },
  watch: {
    fields: {
      handler() {
        // this.setDefaultFields()
      },
      immediate: true,
      deep: true,
    },
    filledFields: {
      handler() {
        this.refreshDisplayedFields()
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>
